import { Paper } from '@lingoda/ui';
import { styled } from '@lingoda/ui/theme';

export const PaperStyled = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(4, 0),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2, 0),
    },
}));
